import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import React from 'react';
export const StyledInfoText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  color: #000000;
`;
